module.exports = __webpack_public_path__ + "static/dennis-1e38fb7863f975631219900e8a9daa57.jpg";